import React from 'react';

const fmt = (bytes) => {
    if (bytes === undefined || bytes === null) return '—';
    if (bytes === 0) return '0 B';
    const gb = bytes / (1024 ** 3);
    if (gb >= 1) return `${gb.toFixed(1)} GB`;
    const mb = bytes / (1024 ** 2);
    if (mb >= 1) return `${mb.toFixed(0)} MB`;
    return `${(bytes / 1024).toFixed(0)} KB`;
};

const StorageBar = ({ used = 0, quota, max, compact = false }) => {
    const hasQuota = quota > 0;
    const pct = hasQuota ? Math.min((used / quota) * 100, 100) : 0;
    const barColor = pct > 90 ? 'bg-red-500' : pct > 70 ? 'bg-amber-400' : 'bg-[#895129]';

    return (
        <div>
            <div className={`flex justify-between ${compact ? 'text-xs' : 'text-sm'} mb-1.5`}>
                <span className="text-slate-500">
                    <span className="font-semibold text-slate-800">{fmt(used)}</span> used
                </span>
                {hasQuota && (
                    <span className="text-slate-400">
                        {fmt(quota)}{max && max !== quota ? ` / ${fmt(max)} max` : ''}
                    </span>
                )}
            </div>
            <div className={`${compact ? 'h-1.5' : 'h-2'} bg-slate-100 rounded-full overflow-hidden`}>
                <div
                    className={`h-full rounded-full transition-all duration-500 ${hasQuota ? barColor : 'bg-slate-200 w-full'}`}
                    style={hasQuota ? { width: `${pct}%` } : undefined}
                />
            </div>
            {!compact && hasQuota && (
                <p className="text-xs text-slate-400 mt-1">{pct.toFixed(0)}% of {fmt(quota)} used</p>
            )}
        </div>
    );
};

export { fmt };
export default StorageBar;
